export default __webpack_public_path__ + "static/SAUNA 2 (1)-2846f77af086b01303208f44ba7b50c1.png";